import React, {useEffect, useState} from 'react';
import Select from "react-select";
import {EMPLOYER_NATIONALITIES} from "@app/constants/Nationality";
import {BDStatusOption, NoteWhenSendCVOption} from "@pages/employer/constant/Constant";
import {AREA_OPTIONS, Provinces} from "@app/constants/Provinces";
import {requestSaveEmployer} from "@app/services/EmployerService";
import {ResponseCode} from "@app/constants/Common";
import {optionsToString, stringToOption} from "@app/utils/CommonUtils";
import {alertMessage, Messages, showMessage} from "@app/constants/Messages";
import {toast} from "react-toastify";
import {cloneDeep} from "lodash";
import {validateEmployerInput} from "@pages/employer/common/ValidationUtil";

const EmployerBasicContent = (props) => {
    const [employer, setEmployer] = useState({});
    const [provinceOptions, setProvinceOptions] = useState([]);
    const [isLoading, setIsLoading] = useState(false)
    const [isEdit, setIsEdit] = useState(false)

    const {employerInput, onChange} = props

    const changeSomeStringValueToOption = (inputEmployerBasic={}) => {
        const emp = cloneDeep(inputEmployerBasic)
        emp.local_nationality = stringToOption(inputEmployerBasic.local_nationality)
        emp.bd_status = stringToOption(inputEmployerBasic.bd_status)
        emp.note_when_send_cv = stringToOption(inputEmployerBasic.note_when_send_cv, false)
        emp.local_province = stringToOption(inputEmployerBasic.local_province)
        emp.local_area = stringToOption(inputEmployerBasic.local_area)

        return emp
    }

    const changeSomeOptionValueToString = (inputEmployerBasic={}) => {
        const strEmpBasic = cloneDeep(inputEmployerBasic)

        strEmpBasic.local_nationality = optionsToString(inputEmployerBasic.local_nationality)
        strEmpBasic.bd_status = optionsToString(inputEmployerBasic.bd_status)
        strEmpBasic.note_when_send_cv = optionsToString(inputEmployerBasic.note_when_send_cv, false)
        strEmpBasic.local_province = optionsToString(inputEmployerBasic.local_province)
        strEmpBasic.local_area = optionsToString(inputEmployerBasic.local_area)

        return strEmpBasic
    }

    useEffect(() => {
        setIsEdit(employerInput && employerInput.id)
        if (employerInput) {
            setEmployer(changeSomeStringValueToOption(employerInput))
        } else {
            setEmployer({})
        }
    }, [employerInput]);

    useEffect(() => {
        if (provinceOptions.length === 0) {
            let provinces = [];
            Provinces.forEach(item => {
                provinces.push({
                    value: item,
                    label: item.charAt(0).toUpperCase() + item.slice(1)
                });
            });
            setProvinceOptions(provinces);
        }
    }, []);

    const onSave= () => {
        if (!validateEmployerInput(employer)) {
            return;
        }
        setIsLoading(true)
        const body = changeSomeOptionValueToString(employer)
        requestSaveEmployer(body).then((res) => {
            console.log(`Response-save user:${JSON.stringify(res)}`);
            if (res.sts_code === ResponseCode.SUCCESS) {
                const newEmployer = res.content
                employer.id = newEmployer.id
                setEmployer({...employer})
                toast.success(Messages.saveInfoSuccess)
            } else {
                alertMessage(res.sts_code, false, true)
                toast.error(Messages.saveInfoSFailed)
            }
        }).catch((error) => {
            console.log(`Error:${JSON.stringify(error)}`);
        }).finally(() => {
        });
    }

    const onChangeEmpCallBack = () => {
        const changeEmployer = changeSomeOptionValueToString(employer)
        if (onChange) {
            onChange(changeEmployer)
        }
    }

    const onChangeEmployerInfo = (fieldName, value) => {
        employer[fieldName] = value
        setEmployer({...employer})

        onChangeEmpCallBack()
    };

    return (
        <div className='card card-default'>
            <div className='card-header'>
                <h3 className='card-title text-bold'>Thông tin cơ bản</h3>
                <div className='card-tools'>
                    <button type='button' className='btn btn-primary'
                            onClick={() => onSave()}>Save
                    </button>
                </div>
            </div>
            <div className='card-body'>
                {employer.id &&
                <div className='input-group'>
                    <label className={'w-100'}>Employer ID: <a href={`/employer/edit/${employer.id}`}>{employer.id}</a></label>
                </div>
                }
                <div className='input-group mt-3'>
                    <label className={'w-100'}>Tên Employer</label>
                    <input type='text' className='form-control'
                           value={employer["name"] ? employer["name"] : ''}
                           name={"name"}
                           onChange={event => onChangeEmployerInfo("name", event.target.value)}/>
                </div>
                <div className='input-group mt-3'>
                    <label className={'w-100'}>Tên Employer (brief)</label>
                    <input type='text' className='form-control'
                           value={employer["brief_name"] ? employer["brief_name"] : ''}
                           name={"brief_name"}
                           onChange={event => onChangeEmployerInfo("brief_name", event.target.value)}/>
                </div>
                <div className='input-group mt-3'>
                    <label className={'w-100'}>Mã số thuế</label>
                    <input type='text' className='form-control'
                           value={employer["mst"] ? employer["mst"] : ''}
                           name={"mst"}
                           onChange={event => onChangeEmployerInfo("mst", event.target.value)}/>
                </div>
                <div className='input-group mt-3'>
                    <label className={'w-100'}>Lưu ý khi gửi CV</label>
                    <div style={{width: '100%'}}>
                        <Select options={NoteWhenSendCVOption}
                                value={employer.note_when_send_cv}
                                onChange={value => {
                                    onChangeEmployerInfo("note_when_send_cv", value);
                                }}
                        />
                    </div>
                </div>
                <div className='input-group mt-3'>
                    <label className={'w-100'}>Quốc tịch</label>
                    <div style={{width: '100%'}}>
                        <Select options={EMPLOYER_NATIONALITIES} isMulti
                                value={employer.local_nationality}
                                onChange={value => {
                                    onChangeEmployerInfo("local_nationality", value);
                                }}
                        />
                    </div>
                </div>
                <div className='input-group mt-3'>
                    <label className={'w-100'}>BD Status</label>
                    <div style={{width: '100%'}}>
                        <Select options={BDStatusOption} isMulti
                                value={employer.bd_status}
                                onChange={value => {
                                    onChangeEmployerInfo("bd_status", value);
                                }}
                        />
                    </div>
                </div>
                <div className='input-group mt-3'>
                    <label className={'w-100'}>Note BD</label>
                    <input type='text' className='form-control'
                           value={employer["bd_note"] ? employer["bd_note"] : ''}
                           name={"bd_note"}
                           onChange={event => onChangeEmployerInfo("bd_note", event.target.value)}/>
                </div>
                <div className='input-group mt-3'>
                    <label className={'w-100'}>Location (Tỉnh)</label>
                    <div style={{width: '100%'}}>
                        <Select options={provinceOptions} isMulti
                                value={employer.local_province}
                                onChange={value => {
                                    onChangeEmployerInfo("local_province", value);
                                }}
                        />
                    </div>
                </div>
                {isEdit &&
                <div className='input-group mt-3'>
                    <label className={'w-100'}><b>Location (Miền)</b></label>
                    <div style={{width: '100%'}}>
                        <Select options={AREA_OPTIONS} isMulti
                                value={employer.local_area}
                                onChange={value => {
                                    onChangeEmployerInfo("local_area", value);
                                }}
                        />
                    </div>
                </div>
                }
            </div>
        </div>
    )
}

export default EmployerBasicContent;
